import React from 'react';
import { SummaryRow } from '../../../Summary/SummaryRow';
import { VQ } from '../../../../store/student/types';
import { IVisaPrepForm, IFamilyMember } from '../../../../types';
import { boolToYesNo } from '../../../../utilities/formatting';
import { parseDate, formatDate } from 'shared-components';
import { Box } from '@chakra-ui/react';
import { SummaryGroup } from '../../../Summary/SummaryGroup';
import { useTranslation } from "react-i18next";

function VisaPrepArrivalInfo(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  const renderFamilyMembers = () => {
    const allFamilyMembers: React.ReactNode[] = [];
    if (props.familyMembers && props.familyMembers.length) {
      props.familyMembers.forEach((familyMember: IFamilyMember, i: number) => {
        allFamilyMembers.push(
          <SummaryGroup title={t('forms.visa:familyMember', { i: i + 1 })} key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.NATIONALITY}-${i}`}
              value={familyMember.nationality}
              label={t('forms.visa:nationality')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.FAMILY_NAME}`}
              value={familyMember.familyName}
              label={t('forms.visa:familyName')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.GIVEN_NAME}`}
              value={familyMember.givenName}
              label={t('forms.visa:givenName')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={VQ.DOB}
              label={t('forms.visa:dateOfBirth')}
              value={familyMember.dob ? formatDate(parseDate(familyMember.dob), 'DD/MM/YYYY') : ''}
            />
          </SummaryGroup>,
        );
      });
    }
    return allFamilyMembers;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_ARRIVAL_DATE}
        label={t('forms.visa:doYouKnowYourPlannedArrivalDateI')}
        value={boolToYesNo(props.hasArrivalDate)}
      />
      {props.hasArrivalDate === true && (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.ARRIVAL_DATE}
            label={t('forms.visa:dateOfPlannedArrivalInTheUk')}
            value={props.arrivalDate}
          />
          <SummaryRow
            className={'visa-summary'}
            title={t('forms.visa:howLongDoYouIntendToStayInTheUk')}
            key={VQ.LENGTH_IN_UK_INTENTION_DD}
            label={t('forms.visa:days')}
            value={`${props.lengthOfStayDays || 0}`}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.LENGTH_IN_UK_INTENTION_MM}
            label={t('forms.visa:months')}
            value={`${props.lengthOfStayMonths || 0}`}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.LENGTH_IN_UK_INTENTION_YY}
            label={t('forms.visa:years')}
            value={`${props.lengthOfStayYears || 0}`}
          />
        </>
      )}
      <SummaryRow
        className={'visa-summary'}
        key={VQ.UK_PRESENCE}
        label={t('forms.visa:doYouHaveAnEstablishedPresenceIn')}
        value={boolToYesNo(props.ukPresence)}
      />
      <SummaryRow
        className={'visa-summary'}
        key={VQ.UK_FAMILY}
        label={t('forms.visa:doYouHaveFamilyInTheUk')}
        value={boolToYesNo(props.ukFamily)}
      />
      {props.ukFamily ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.STAYING_WITH_FAMILY}
            label={t('forms.visa:willYouBeStayingWithAnyFamilyMem')}
            value={boolToYesNo(props.stayingWithFamily)}
          />
          {props.stayingWithFamily ? (
            <>
              <SummaryRow
                className={'visa-summary'}
                label={t('forms.visa:howManyFamilyMembersWillYouBeSta')}
                value={props.familyMembers?.length}
              />
              <Box as="ol" pl={8} key={'Family members'}>
                {renderFamilyMembers()}
              </Box>

              <SummaryRow
                className={'visa-summary'}
                key={VQ.FAMILY_CONTACT_ADDRESS}
                label={t('forms.visa:contactAddressForFamilyYouAreSta')}
                value={props.familyContactAddress}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.FAMILY_CONTACT_CITY}
                label={t('forms.visa:city')}
                value={props.familyContactCity}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.FAMILY_CONTACT_POSTCODE}
                label={t('forms.visa:postcode')}
                value={props.familyContactPostcode}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.FAMILY_CONTACT_COUNTRY}
                label={t('forms.visa:country')}
                value={props.familyContactCountry}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.FAMILY_CONTACT_NUMBER}
                label={t('forms.visa:contactNumber')}
                value={props.familyPhoneNumber}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.FAMILY_CONTACT_EMAIL}
                label={t('forms.visa:contactEmailAddress')}
                value={props.familyEmail}
              />
            </>
          ) : null}
        </>
      ) : null}
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_OTHER_CONTACT_ADDRESS}
        label={t('forms.visa:doYouHaveAnotherAddressInTheUk')}
        value={boolToYesNo(props.hasOtherContactAddress)}
      />
      {props.hasOtherContactAddress ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.OTHER_CONTACT_ADDRESS}
            label={t('forms.visa:ukContactAddress')}
            value={props.otherContactAddress}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.OTHER_CONTACT_CITY}
            label={t('forms.visa:city')}
            value={props.otherContactCity}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.OTHER_CONTACT_POSTCODE}
            label={t('forms.visa:postcode')}
            value={props.otherContactPostcode}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.OTHER_CONTACT_COUNTRY}
            label={t('forms.visa:country')}
            value={props.otherContactCountry}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.OTHER_CONTACT_NUMBER}
            label={t('forms.visa:contactNumber')}
            value={props.otherPhoneNumber}
          />
        </>
      ) : null}
    </>
  );
}

export default VisaPrepArrivalInfo;
